import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {Http} from '@angular/http';
import { HttpClientService } from './common/http-client.service';
import { AuthService } from './auth/auth.service';
import 'rxjs/add/operator/map';
import { environment } from 'environments/environment.mock';
import { CommonService } from './common/common.service';

@Injectable()
export class AccessProvider {

    private accessData: any;

    constructor(private http: HttpClientService, private authService: AuthService,
       private injector: Injector,private commonService :CommonService) {

    }

    public get router(): Router { //this creates router property on your service.
      return this.injector.get(Router);
   }

    public getAccessData(): any {
        return this.accessData;
    }

    load() {
        return new Promise((resolve, reject) => {
            let isLoggeIn = '';
            isLoggeIn = localStorage.getItem('loggedAt');
            if(!environment.production){
              this.authService.userInfo = this.commonService.getStorage('userInfo');
            }
          // ***DANGER*** login ByPass - AMMY-NEED-TO-REMOVE-IT
          //   if(localStorage.getItem('loggedAt') && !this.authService.userInfo){
          //   this.http.get('userManagement/userDetails',null,7).subscribe((res)=>{
          //     this.accessData = res['object']?res['object'][0]:null;             
          //     resolve(true);
          //   });
          // }
          //else {
            resolve(true);
         // }
        });
    }
}


// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/access-provider.ts